// extracted by mini-css-extract-plugin
export default {"root":"gaxwxS","category":"SkQy7B","newCategoryUi":"UQIIbV","searchFadeIn":"syOJbg"};